export const CURRENCY = 'грн';

/**
 * Free-shipping offer — PAUSED 2026-08-16. The progress card no longer renders
 * (initShipBanner() is not called from sections/summary/summary.js), so these
 * two constants are currently unused. Kept so restoring the offer is a one-line
 * change rather than a rewrite.
 */
export const FREE_SHIPPING_THRESHOLD = 5000;

/**
 * Minimum payable order amount (post-discount grand total, UAH). Carts under
 * this value can't be submitted — the pay button is disabled and a small
 * notice tells the customer how much they need to add. Set to 0 to disable.
 */
export const MINIMUM_ORDER_VALUE = 300;

/**
 * Product tags that opt an item OUT of the free-shipping threshold.
 * Add ANY of these in Shopify admin to a bulky / high-volume product whose
 * shipping cost would eat the merchant's margin. Matched case-insensitively
 * against each cart line's product.tags — a single hit on any tag in this
 * list disqualifies the whole cart from free shipping.
 */
export const FREE_SHIPPING_DISQUALIFIER_TAGS = ['big_item', 'XL'];

/**
 * Upsell stock policy.
 *
 * A variant is offered as an upsell only when Shopify reports it as sellable.
 * Shopify's `availableForSale` is true in TWO cases: real stock on hand, OR
 * zero stock with "continue selling when out of stock" enabled (a backorder).
 * `currentlyNotInStock` distinguishes them.
 *
 * ALLOW_BACKORDER=false  → only variants with real stock are offered (strictest)
 * ALLOW_BACKORDER=true   → backorder-enabled variants are offered too
 *
 * Out of stock WITHOUT "continue selling" is never offered under either setting
 * — Shopify marks those `availableForSale: false` and they are always excluded.
 *
 * TWO KNOBS, KEEP THEM IN AGREEMENT. This constant governs the CLIENT-side
 * backstop in sections/summary/upsell.js. The server does the actual filtering
 * and reads its own switch, the `UPSELL_ALLOW_BACKORDER` env var (see
 * server/routes/recommendations.js) — which defaults to true, matching this.
 * To tighten the policy, change BOTH: set this to false and rebuild, and set
 * UPSELL_ALLOW_BACKORDER=false in .env and restart.
 */
export const UPSELL_STOCK = {
  ALLOW_BACKORDER: true,
};

/**
 * Stock-urgency banner. Shows when the lowest tracked-stock value among the
 * cart's lines drops below `threshold`. The `{n}` placeholder in `template`
 * is replaced with the actual minimum stock at render time.
 */
export const URGENCY = {
  show: true,
  threshold: 20,
  template: 'Поспішайте! Лише {n} товарів в наявності!',
};

// The two free-shipping bullets were removed 2026-08-16 alongside the
// free-shipping card, so the checkout no longer advertises an offer that is
// currently paused. Restore them here if the offer comes back.
export const POLICY_TEXT = [
  'Вартість доставка за тарифами Нової пошти (від 80 грн)',
  'Менеджер може запросити предоплату в розмірі від 100 грн або 10% від вартості замовлення.',
  'Доставка Укрпоштою тільки по повній предоплаті.',
];

// Fallback cart used when no real Shopify cart token is present in the URL.
// In production, Shopify Admin API (server-side) hydrates the cart from the
// `cartToken` query param that chekly-script appends to the redirect URL.
export const FALLBACK_CART_ITEMS = [
  {
    id: 'sku-001',
    name: 'Органайзер для взуття вузький багаторівневий',
    variant: '6 секцій (108 см)',
    price: 1300.00,
    qty: 1,
    image: null,
    placeholder: 'product\nshot',
  },
];

export const FALLBACK_UPSELL_PRODUCTS = [
  { id: 'up-1', name: 'Складна шафа для зберігання з прозорими дверцятами', price: 3400, image: null, placeholder: 'shoe\ncab' },
  { id: 'up-2', name: 'Модульна шафа для взуття з дверцятами та колесами', price: 1500, image: null, placeholder: 'modular' },
  { id: 'up-3', name: 'Пластиковий ящик для зберігання на колесах з кришкою', price: 1400, image: null, placeholder: 'bin' },
  { id: 'up-4', name: 'Універсальна тумба для спальні та вітальні на колесах', price: 1550, image: null, placeholder: 'cabinet' },
  { id: 'up-5', name: 'Компактна складна полиця для взуття', price: 350, image: null, placeholder: 'shelf' },
];
